<template>
  <el-dialog
    title="修改记录"
    :visible="true"
    width="850px"
    top="5vh"
    :before-close="() => $emit('close')"
  >
    <el-form
      :model="ruleForm"
      disabled
      ref="ruleForm"
      label-width="220px"
      class="ruleForm rmgt"
    >
      <el-alert type="warning" :closable="false">
        注：风控规则由向日葵平台保留最终解释权，所有风控内容最终以向日葵平台设置的可调范围为准。
      </el-alert>
      <div class="mb20"></div>
      <el-form-item label="执行者年龄区间：">
        <el-input :value="ruleForm.ageStart" placeholder="">
          <span slot="suffix">岁</span>
        </el-input>
        <span class="line"></span>
        <el-input :value="ruleForm.ageEnd" placeholder="">
          <span slot="suffix">岁</span>
        </el-input>
      </el-form-item>

      <!-- 自答模式-->
      <el-form-item label="项目执行人单篇文章：" v-if="answerMode === 1">
        <el-input ref="formItemInput" v-model="ruleForm.monthNumber">
          <span slot="suffix">自然月内</span>
        </el-input>
        可提交
        <el-input ref="formItemInput" v-model="ruleForm.monthNumberSubmit">
          <span slot="suffix">次</span>
        </el-input>
      </el-form-item>
      <el-form-item label="项目执行人单篇文章：" v-if="answerMode === 1">
        <el-input ref="formItemInput" v-model="ruleForm.dayNumber">
          <span slot="suffix">天内</span>
        </el-input>
        可提交
        <el-input ref="formItemInput" v-model="ruleForm.dayNumberSubmit">
          <span slot="suffix">次</span>
        </el-input>
      </el-form-item>
      <!-- 自答模式-->
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  name: 'digitalSurveyDetail',
  props: ['row'],
  data() {
    return {
      ruleForm: {
        ageStart: '',
        ageEnd: '',
        monthNumber: '',
        monthNumberSubmit: '',
        dayNumber: '',
        dayNumberSubmit: ''
      },
      rawRespondData: null,
      answerMode: null // 1 自答 2 分享
    };
  },
  async created() {
    // 问答模式
    this.answerMode = this.$store.state.homeProject.answerMode;
    // 缓存 原始 响应数据
    // this.rawRespondData = data;

    this.ruleForm = JSON.parse(this.row.updateJson);
  }
};
</script>
<style lang="scss">
.rmgt {
  .el-input__suffix {
    right: 12px;
    color: #000;
  }
}

.risk-box {
  .ruleForm .el-form-item .el-input {
    width: 160px;
  }
}
</style>
<style scoped lang="scss">
.ruleForm {
  padding: 0;
}

.risk-tips {
  color: #9d9d9d;
  font-size: 13px;
  margin-bottom: 40px;
}

.note-s1 {
  margin-left: 30px;
  color: #9d9d9d;
  font-size: 13px;
}

.distance {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.check {
  position: absolute;
  right: 30.68%;
}

.line {
  width: 16px;
  height: 1px;
  background: #dedede;
  margin: 0 12px;
  display: inline-block;
}
</style>
